import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const TemplateCard = ({ template, onPreview, onUse, applying }) => {
  return (
    <div className="bg-card rounded-lg border border-border overflow-hidden hover:shadow-lg transition-all duration-300 group">
      <div className="relative aspect-[4/3] overflow-hidden bg-muted">
        <Image
          src={template?.thumbnail}
          alt={template?.thumbnailAlt}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background/80 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end justify-center pb-4 gap-2">
          <Button
            variant="secondary"
            size="sm"
            iconName="Eye"
            iconPosition="left"
            onClick={() => onPreview(template)}
          >
            Preview
          </Button>
          <Button
            variant="default"
            size="sm"
            iconName={applying ? 'Loader2' : 'Plus'}
            iconPosition="left"
            disabled={applying}
            onClick={() => onUse(template)}
          >
            {applying ? 'Creating...' : 'Use Template'}
          </Button>
        </div>
        {template?.isNew && (
          <div className="absolute top-3 right-3 bg-accent text-accent-foreground px-2 py-1 rounded text-xs font-medium">
            New
          </div>
        )}
        {template?.isPro && (
          <div className="absolute top-3 left-3 bg-primary text-primary-foreground px-2 py-1 rounded text-xs font-medium flex items-center gap-1">
            <Icon name="Crown" size={12} />
            Pro
          </div>
        )}
      </div>
      <div className="p-4 md:p-5">
        <div className="flex items-start justify-between gap-2 mb-2">
          <h3 className="font-semibold text-base md:text-lg text-foreground line-clamp-1">
            {template?.name}
          </h3>
          <div className="flex items-center gap-1 text-warning flex-shrink-0">
            <Icon name="Star" size={14} className="fill-current" />
            <span className="text-xs font-medium whitespace-nowrap">{template?.rating}</span>
          </div>
        </div>

        <p className="text-sm text-muted-foreground mb-3 line-clamp-2">
          {template?.description}
        </p>

        <div className="flex flex-wrap items-center gap-2 mb-3">
          <span className="inline-flex items-center gap-1 px-2 py-1 bg-muted rounded text-xs text-muted-foreground">
            <Icon name="Tag" size={12} />
            {template?.category}
          </span>
          <span className="inline-flex items-center gap-1 px-2 py-1 bg-muted rounded text-xs text-muted-foreground">
            <Icon name="Layout" size={12} />
            {template?.pages} pages
          </span>
        </div>

        <div className="flex items-center justify-between pt-3 border-t border-border">
          <div className="flex items-center gap-1 text-muted-foreground">
            <Icon name="Download" size={14} />
            <span className="text-xs">{template?.downloads}</span>
          </div>
          <div className="flex items-center gap-1 text-muted-foreground">
            <Icon name="Clock" size={14} />
            <span className="text-xs">{template?.lastUpdated}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TemplateCard;